import React from 'react';

import { styled } from 'styled-components';

interface RightComponentProps {
  children: React.ReactNode;
}

const OverviewChannel = styled.div`
  width: 50vw;
  height: 70%;
  padding: 21px 20px 35.62px 20px;
  background: #f2f4f7;
  border-left: 1px solid rgba(230, 232, 236, 0.9);
  /* margin-right: -6.6vw; */
`;
const DotPattern = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  background-image: radial-gradient(
    rgba(88, 98, 114, 0.34) 0.752px 0.873px,
    transparent 0
  );

  background-size: 15.78px 17.6px;
  background-position: -19px -19px;
`;

const RightComponent = ({ children }: RightComponentProps) => {
  return (
    <OverviewChannel>
      <DotPattern>{children}</DotPattern>
    </OverviewChannel>
  );
};

export default RightComponent;
